// ============================================
// MERGE SHOPIFY HEADER BUTTONS INTO CUSTOM NAV
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  // Find Shopify's header buttons container
  const shopifyHeader = document.querySelector('header[role="banner"]') ||
                       document.querySelector('.header') ||
                       document.querySelector('[data-section*="header"]');

  if (shopifyHeader) {
    // Find all header icon buttons (PYG, search, account, cart)
    const buttons = shopifyHeader.querySelectorAll('[class*="icon"], button, a[href*="cart"], a[href*="account"]');

    // Move them into our nav's placeholder
    const navPlaceholder = document.querySelector('.nav-shopify-buttons');
    if (navPlaceholder && buttons.length > 0) {
      buttons.forEach(btn => {
        navPlaceholder.appendChild(btn.cloneNode(true));
      });
    }
  }
});

// ============================================
// CURSOR GLOW
// ============================================
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!window.matchMedia('(pointer: coarse)').matches) {
  const glow = document.getElementById('cursor-glow');
  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let gx = mx, gy = my;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; }, { passive: true });
  (function tick() {
    gx += (mx - gx) * 0.075;
    gy += (my - gy) * 0.075;
    glow.style.left = gx + 'px';
    glow.style.top  = gy + 'px';
    requestAnimationFrame(tick);
  })();
}

// ============================================
// NAV SCROLL SOLID
// ============================================
const nav = document.getElementById('nav');
const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 50);
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

// ============================================
// SCROLL REVEAL
// ============================================
if (!reducedMotion) {
  const revEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  const revIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); revIO.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
  revEls.forEach(el => revIO.observe(el));
} else {
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => el.classList.add('in'));
}

// ============================================
// PRODUCT REVEAL CIRCLE
// ============================================
const productWrap = document.getElementById('product-img-wrap');
if (productWrap) {
  const circleIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        productWrap.classList.add('circle-in');
        circleIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  circleIO.observe(productWrap);
}

// ============================================
// MUTE / UNMUTE BUTTON
// ============================================
const video     = document.getElementById('phone-video');
const muteBtn   = document.getElementById('mute-btn');
const iconMuted = document.getElementById('icon-muted');
const iconSound = document.getElementById('icon-sound');

if (muteBtn && video) {
  muteBtn.addEventListener('click', () => {
    video.muted = !video.muted;
    if (video.muted) {
      iconMuted.style.display = '';
      iconSound.style.display = 'none';
      muteBtn.setAttribute('aria-label', 'Unmute video');
    } else {
      iconMuted.style.display = 'none';
      iconSound.style.display = '';
      muteBtn.setAttribute('aria-label', 'Mute video');
      video.play().catch(() => {});
    }
  });
}
